/* eslint-disable @typescript-eslint/no-unused-expressions */
import AppEnvironment from '../../environment/app-environment';
/**
 * The ConsoleLogger class provides the console logging functionality.
 * This is to be used during developmentand debuggin mainly of MSAL
 */
class ConsoleLoggerService {
  /** The flag to keep track of logging enabled. */
  private loggingEnabled = false;

  /** This flag enables Msal console logging */
  private msalLoggingEnabled = false;

  constructor() {
    // We will search for a logginEnabled flag on the localStorage on the env variables. This opens the possibility to
    // Enable logging on demand on any environment.
    const value = window.localStorage.getItem('loggingEnabled') || `${AppEnvironment.consoleLogging}`;
    const msalValue = window.localStorage.getItem('msalLoggingEnabled') || `${AppEnvironment.msalConsoleLogging}`;
    this.loggingEnabled = value === 'true';
    this.msalLoggingEnabled = msalValue === 'true';
  }

  /**
   * Logs the message as normal to console.
   * @param message - The message
   */
  public log(message: any, ...optionalParams: any[]) {
    this.loggingEnabled && window.console.log(message, optionalParams);
  }

  /**
   * Logs the message as warning to console.
   * @param message
   */
  public warn(message: any, ...optionalParams: any[]) {
    this.loggingEnabled && window.console.warn(message, optionalParams);
  }

  /** Logs msal messages to console */
  public msalLog(message: any, ...optionalParams: any[]) {
    this.msalLoggingEnabled && window.console.log(message, optionalParams);
  }

  /** Logs msal verbose messages to console debug(hidden if console does not have verbose enabled) */
  public msalVerbose(message: any, ...optionalParams: any[]) {
    this.msalLoggingEnabled && window.console.debug(message, optionalParams);
  }
}

/**
 * Export the singleton instance of the class.
 */
export const consoleLogger = new ConsoleLoggerService();
